export default __webpack_public_path__ + "static/media/ycLogo.26838bc0.png";